import disabledEmphasis from '../../../text/disabled-emphasis';

const secondary = (params) => disabledEmphasis(params);

export default secondary;
